import React, {Fragment, useEffect, useReducer, useState} from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from '../ModalContentWrapper';
import {getNewsItemDetails, setNewsAsRead} from "../../../DataFunctions/NewsDataFns";
import {getDataFromResponse} from "../../../DataFunctions/BaseDataFns";
import SpinnerDiv from "../../../Forms/UI/SpinnerDiv";
import {useForm} from "react-hook-form";

const ModalViewNews = (props) =>
{
    const [ ,forceRender] = useReducer((s) => s+1, 0)
    const [data, setData] = useState({ isLoading: true, data: [] });
    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                news: {
                    title: '',
                    text: '',
                    owner: ''
                }
            }
        });

    useEffect(() =>
    {
        if(props.news_id !== null)
        {
            getNewsItemDetails(props.news_id, (response) =>
            {
                let newsData = getDataFromResponse(response)[0];

                setValue('news',
                    {
                        title: newsData.title,
                        text: newsData.text,
                        owner: newsData.owner
                    });

                setData({isLoading: false, data: newsData});

                //Now we need to mark the news as read
                doSetNewsAsRead();
            });
        }

    }, [props.news_id]);

    const doSetNewsAsRead = () =>
    {
        setNewsAsRead(props.news_id, (response) =>
        {
            //
        });
    }

    const Title = ( props ) =>
    {
        return <h3>News Item</h3>
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('saved');
        props.onClose() ;
    }

    const renderHookForm = ( prop )  =>
    {
        return (
            <Fragment>
                <form className='registration-form' >
                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>From</label>
                                <input readOnly='readonly' className='form-control' name='news.owner' id='owner' {...register("news.owner", { required: false})} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Title</label>
                                <input readOnly='readonly' className='form-control' name='news.title' id='title' {...register("news.title", { required: false})} />
                            </div>
                        </div>
                    </div>

                    <div dangerouslySetInnerHTML={{__html: data.data['text']}} />

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button onClick={onClickCancel} className="btn btn-secondary">Close<i className="et-arrow-bold-left" /></button>
                    </div>

                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />
            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>

        </ModalContentWrapper>
    )
}

export default ModalViewNews;

ModalViewNews.defaultProps =
    {
        width: '400px'
    }

ModalViewNews.propTypes = {
    news_id: PropTypes.string,
    width: PropTypes.string,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
